import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { getBySlug } from "@/data/calculators";
import * as All from "@/calculators";
import NotFound from "@/pages/NotFound";

export default function CalculatorPage() {
  const { slug } = useParams();
  const calc = getBySlug(slug);

  useEffect(() => {
    if (!calc) return;
    document.title = `${calc.name} — Free Online Calculator | FitnessCalculator`;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute(
      "content",
      calc.description ||
        `Free, instant ${calc.name} — no sign-up required.`
    );
  }, [calc]);

  if (!calc) return <NotFound />;
  const Component = All[calc.componentKey];
  if (!Component) return <NotFound />;
  return <Component calc={calc} />;
}
